import React from 'react';
import { useIsFetching } from 'react-query';
import { useTheme } from 'styled-components';

import { Select } from 'common/components/form/Select/Select';
import { useScreenSizeDetection } from 'common/hooks';
import { Flex } from 'components/styled/Flex';

interface ISelectOptions {
  label: string;
  value: string;
  placeholder: string;
}

interface IProps {
  selectOptions: ISelectOptions[];
  equalsToParam: string | null;
  handleFilterChange: (key: string, value: string) => void;
  handleSearchInputChange?: (value: string) => void;
  children?: React.ReactNode;
}
export const CategorySearch = ({
  selectOptions,
  equalsToParam,
  handleFilterChange,
  children,
}: IProps) => {
  const isFetching = useIsFetching();
  const { isMobile } = useScreenSizeDetection();
  const { colors } = useTheme();
  const orderByDropdownMobileStyles = {
    valueContainer: { display: 'none' },
    menu: { width: '9rem' },
    control: {
      minWidth: '3rem',
      padding: '0 !important',
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
    option: (provided: any, state: { isSelected: boolean }) => ({
      ...provided,
      backgroundColor: state.isSelected ? colors.primary : provided.backgroundColor,
      color: state.isSelected ? 'white' : provided.color,
      '&:hover': {
        backgroundColor: state.isSelected ? colors.primary : colors.black_20,
      },
    }),
  };
  const orderByDropdownStyles = {
    control: {
      minWidth: '8rem',
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
    option: (provided: any, state: { isSelected: boolean }) => ({
      ...provided,
      backgroundColor: state.isSelected ? colors.primary : provided.backgroundColor,
      color: state.isSelected ? colors.white : provided.color,
      '&:hover': {
        backgroundColor: state.isSelected ? colors.primary : colors.black_20,
      },
    }),
  };

  const hasGlobalSearch = selectOptions.some(option => option.value === 'globalSearch');

  return (
    <Flex>
      {!hasGlobalSearch && (
        <Select
          name="orderBy"
          options={selectOptions}
          defaultValue={
            selectOptions.find(option => option.value === equalsToParam) || selectOptions[0]
          }
          // disabled={!!isFetching}
          onChange={e => {
            handleFilterChange('equalsTo', e.value);
          }}
          extendStyles={isMobile ? orderByDropdownMobileStyles : orderByDropdownStyles}
        />
      )}
      <div style={{ width: isMobile ? '25rem' : '20rem' }}>{children}</div>
    </Flex>
  );
};
